import Loading from '@app/components/legacy/loading';
import style from './loading-screen.module.scss';

const LoadingScreen = () => (
  <div className={style.Loading}>
    <Loading />
  </div>
);

export default LoadingScreen;
